import React from 'react';
import Bk3Referees from './Bk3Referees';
import Bk3PlayerList from './Bk3PlayerList';


const Bk3StartList = ({ data }) => {
  return (
    <>
    <Bk3PlayerList data={data}/>
    <Bk3Referees data={data}/>
    </>
  );

}

export default Bk3StartList;